module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-400italic.woff?56bdf84751634e8deaff10d1d68df316";